import { type ReactNode } from 'react';
import {
  NavigationContext,
  type NavigationContextValue,
} from '@client/contexts/NavigationContext';
import { ClientOverrideProvider } from '@client/contexts/ClientOverrideContext';

const PREVIEW_CLIENT = { clientFullName: 'Preview Client' };

interface PreviewNavigationProviderProps {
  children: ReactNode;
  formDefinition: PolicyFormDefinition;
  formData: PolicyFormSubmissionData;
  onFormDataChange: (questionRef: string, value: PolicyFormSubmissionDataValue) => void;
}

export function PreviewNavigationProvider({
  children,
  formDefinition,
  formData,
  onFormDataChange,
}: PreviewNavigationProviderProps) {
  const noop = () => {};

  const contextValue: NavigationContextValue = {
    state: {
      type: 'idle',
      currentPosition: null,
      visitedSubsections: new Set(),
      formData,
      progress: null,
    },
    navigationService: null as any,
    formDefinition,
    clientPolicyApplicationId: '',
    animationDirection: 1,
    actions: {
      navigateTo: noop,
      navigateNext: noop,
      navigatePrevious: noop,
      updateFormData: (_questionRef, value) => onFormDataChange(_questionRef, value),
      markVisited: noop,
      initialize: noop,
      clearError: noop,
      showValidationErrors: noop,
      setFieldValidationError: noop,
      clearFieldValidationErrors: noop,
      recomputeAllWarnings: noop,
    },
    computed: {
      canGoNext: false,
      canGoPrevious: false,
      isLastStep: false,
      isLoading: false,
      isSaving: false,
      hasError: false,
    },
    getCurrentSubsection: () => null,
    getCurrentSection: () => null,
    validationState: {
      showValidationErrors: false,
      missingRequiredFields: [],
      fieldValidationErrors: new Map(),
    },
  };

  return (
    <ClientOverrideProvider client={PREVIEW_CLIENT}>
      <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>
    </ClientOverrideProvider>
  );
}
